import React, { useState } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaTable } from 'react-icons/fa';
import Data from '../../components/Data';
import ReactSelect from '../../components/ReactSelect';
import api from '../../services/api';
import '../../css/financeiro-parcela-pagar.css';

export default function EventoRelatorio() {
    const token = localStorage.getItem('token');
    const empresa = localStorage.getItem("empresa");
    const [filtro, setFiltro] = useState({
        empresa: empresa,
        cliente: [],
    });

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Relatório de Eventos</h1></div>
                    <div className="fin-pp__actions"></div>
                </div>

                <form method="post" target="_blank" action={process.env.REACT_APP_API_URL + "/evento/exportarEventoRelatorio"}>
                    <input type="hidden" name="token" value={token} />
                    <input type="hidden" name="empresa" value={empresa} />
                    <input type="hidden" name="cliente" value={filtro.cliente && Array.isArray(filtro.cliente) ? filtro.cliente.map(item => item.value).join(',') : ''} />

                    <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                        <div className="fin-pp__filters">
                            <div className="fin-pp__field">
                                <Data
                                    inputName="data1"
                                    label="Data"
                                    value={filtro.data1}
                                    onChange={date => setFiltro({ ...filtro, ...{ "data1": date } })}
                                />
                            </div>
                            <div className="fin-pp__field">
                                <Data
                                    inputName="data2"
                                    label="até a Data"
                                    value={filtro.data2}
                                    onChange={date => setFiltro({ ...filtro, ...{ "data2": date } })}
                                />
                            </div>
                            <div className="fin-pp__field" style={{ flex: '0 0 100%' }}>
                                <label className="fin-pp__label">Cliente</label>
                                <ReactSelect
                                    isMulti={true}
                                    id="cliente"
                                    value={filtro.cliente}
                                    onChange={(e) => {
                                        setFiltro({ ...filtro, ...{ "cliente": e } });
                                    }}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/participante',
                                            token: token,
                                            params: {
                                                nome: input,
                                                tipoCadastro: "cliente",
                                                situacaoRegistro: "ativo",
                                            }
                                        })
                                            .then(response => {
                                                let options = response.data.data.map((registro) => {
                                                    var label = registro.codigo +
                                                        ' - ' + registro.nome +
                                                        (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '') +
                                                        (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
                                                        (registro.cpf ? ' (' + registro.cpf + ')' : '') +
                                                        (registro.nomefantasia ? ' - ' + registro.nomefantasia : '');
                                                    return {
                                                        value: registro.id,
                                                        label: label
                                                    };
                                                });
                                                return options;
                                            })
                                            .catch(function (error) {
                                                //console.log(error);
                                            });
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 24 }}>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary">
                            <FaTable size={16} /> Gerar Planilha
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
